export const TRIP_PROTECTION_COVERAGE_OPTIONS = [
  { value: "liability", label: "Liability Insurance" },
  { value: "trip_accident", label: "Travel Accident Insurance" },
  {
    value: "emergency_assist_and_transport",
    label: "Emergency Assistance & Transportation Insurance",
  },
  {
    value: "emergency_medical_and_dental",
    label: "Emergency Medical & Dental Insurance",
  },
];
